import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const wrapper = {
  ...sharedStyles.column,
  alignItems: 'center',
  padding: '16px 0',
}

export const wrapperRow = {
  ...sharedStyles.row,
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px 0',
}

export const text = {
  ...sharedStyles.subheading,
}

export const textEllipsis = {
  ...text,
  ...sharedStyles.textEllipsis,
}

export const textEmpty = {
  ...text,
  ...sharedStyles.textDisabled,
}

export const textEllipsisEmpty = {
  ...textEllipsis,
  ...sharedStyles.textDisabled,
}

export const icon = { width: 36, height: 36, flexShrink: 0 }

export const iconRow = { ...icon, marginRight: 8 }
